import {
  GET_RECEPTION_DATA_LIST_FAILED,
  GET_RECEPTION_DATA_LIST_REQUEST,
  GET_RECEPTION_DATA_LIST_SUCCESS,
} from 'constants/actionTypes/receptionDataActionTypes'

const listReceptionData = (state = { listReceptionData: [] }, action) => {
  switch (action.type) {
    case GET_RECEPTION_DATA_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        type: GET_RECEPTION_DATA_LIST_REQUEST,
      }
    case GET_RECEPTION_DATA_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        listReceptionData: action.payload,
        type: GET_RECEPTION_DATA_LIST_SUCCESS,
      }
    case GET_RECEPTION_DATA_LIST_FAILED:
      return {
        ...state,
        loading: false,
        listReceptionData: [],
        message: action.payload,
        type: GET_RECEPTION_DATA_LIST_FAILED,
      }
    default:
      return state
  }
}
export { listReceptionData }
